import React from "react";

import { ColumnProps, RowCompareFn, RowData, SortDirection } from "./types";

export function useSort(
	columns: ColumnProps[],
	data: RowData[],
	key: string,
	dir: SortDirection,
	preCompareFn: RowCompareFn | undefined
): RowData[] {
	return React.useMemo(() => {
		const { compare, mapToString } =
			columns.find(column => column.key === key) || {};
		const sortedData = [...data];
		const factor = dir === "asc" ? 1 : -1;
		sortedData.sort((itemA, itemB) => {
			if (preCompareFn !== undefined) {
				const t = preCompareFn(itemA, itemB);
				if (t !== 0) {
					return t;
				}
			}
			let a = itemA[key];
			let b = itemB[key];
			if (compare !== undefined) {
				return factor * compare(a, b);
			}
			if (mapToString !== undefined) {
				a = mapToString(a);
				b = mapToString(b);
			}
			if (typeof a === "string" && typeof b === "string") {
				return factor * a.localeCompare(b);
			}
			if (
				(typeof a === "number" && typeof b === "number") ||
				(typeof a === "boolean" && typeof b === "boolean")
			) {
				return factor * scalarCompare(a, b);
			}
			return 0;
		});
		return sortedData;
	}, [columns, data, key, dir, preCompareFn]);
}

function scalarCompare<T = number | boolean>(a: T, b: T): number {
	if (a < b) {
		return -1;
	}
	if (a > b) {
		return 1;
	}
	return 0;
}
